import { FOIL_COLOR_LABELS } from 'cards/constants/foilColorLabels';

export const getFoilColorLabel = foilColor => FOIL_COLOR_LABELS[foilColor.toLowerCase()];
